import { analytics } from './index'

// Initiative events
export const trackInitiativeOpened = (
  ideaId: string,
  ideaName?: string,
  source?: 'kanban' | 'list' | 'feed',
) => analytics.track('initiative_opened', { ideaId, ideaName, source })

export const trackInitiativeFieldViewed = (
  ideaId: string | null | undefined,
  field: string,
) => analytics.track('initiative_field_viewed', { ideaId, field })

export const trackInitiativeStageChanged = (params: {
  ideaId: string
  fromColumnName?: string
  toColumnName?: string
  newKanbanColumnId: string
}) => analytics.track('initiative_stage_changed', params)

export const trackFirstInitiativeDetailViewed = (
  ideaId: string,
  ideaName?: string,
) => analytics.track('first_initiative_detail_viewed', { ideaId, ideaName })

// Idea form events
export const trackIdeaFormOpened = (
  challengeId: string,
  challengeName: string,
) => analytics.track('idea_form_opened', { challengeId, challengeName })

export const trackIdeaDraftSaved = (
  challengeId: string,
  challengeName: string,
) => analytics.track('idea_draft_saved', { challengeId, challengeName })

export const trackIdeaSubmitted = (params: {
  challengeId: string
  challengeName: string
  participantCount: number
  hasFile: boolean
  hasLinks: boolean
}) => analytics.track('idea_submitted', params)

export const trackIdeaSubmissionFailed = (
  challengeId: string,
  challengeName: string,
) => analytics.track('idea_submission_failed', { challengeId, challengeName })

export const trackIdeaFormAbandoned = (
  challengeId: string,
  challengeName: string,
) => analytics.track('idea_form_abandoned', { challengeId, challengeName })

export const trackIdeaApproved = (ideaId: string) =>
  analytics.track('idea_approved', { ideaId })

// Navigation / page events
export const trackPageViewed = (page_type: string) =>
  analytics.track('page_viewed', { page_type })

export const trackFirstDashboardViewed = () =>
  analytics.track('first_dashboard_viewed')

export const trackFirstFunnelViewed = () =>
  analytics.track('first_funnel_viewed')

export const trackFirstRankingViewed = () =>
  analytics.track('first_ranking_viewed')

export const trackFirstProjectAreaViewed = (
  portfolioId: string,
  portfolioName?: string,
) =>
  analytics.track('first_project_area_viewed', { portfolioId, portfolioName })

// Auth / session events
export const trackLoginCodeSent = (method: string) =>
  analytics.track('login_code_sent', { method })

export const trackLoginCodeSendFailed = (method: string) =>
  analytics.track('login_code_send_failed', { method })

export const trackLoginCodeVerified = (email: string) =>
  analytics.track('login_code_verified', { email })

export const trackLoginCodeVerificationFailed = (email: string) =>
  analytics.track('login_code_verification_failed', { email })

export const trackPasswordResetRequested = () =>
  analytics.track('password_reset_requested')

export const trackInviteLinkOpened = (inviteId: string) =>
  analytics.track('invite_link_opened', { inviteId })

export const trackInviteRegistrationCompleted = (inviteId: string) =>
  analytics.track('invite_registration_completed', { inviteId })

export const trackSessionIdentified = (params: {
  userId: string
  tenantId: string
  tenantSlug: string
  role: string
  timestamp: string
}) => analytics.track('session_identified', params)

export const trackTenantSessionStart = (params: {
  tenantId: string
  tenantName: string
  tenantSlug: string
  tenantStatus: string
}) => analytics.track('tenant_session_start', params)

// Project / portfolio events
export const trackTaskStatusChanged = (params: {
  taskId: string
  taskName: string | undefined
  completed: boolean
  projectName: string | undefined
  portfolioName: string | undefined
}) => analytics.track('task_status_changed', params)
